
define('ldsh!modules/domain_listing/templates/confirm_delete_popup', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-overlay-container">\n  <div class="ed-opt-toolbar ed-modal-header">\n    <div class="ed-close-wrapper">\n      <i class="ri-close-line js-close" data-dismiss="modal"></i>\n    </div>\n    <h3 data-i18n="domainListing.dialog.delete.title" class="ed-modal-title"></h3>\n  </div>\n\n  <div class="ed-modal-content">\n      <p\n        data-i18n="domainListing.dialog.delete.confirm"\n        class="ed-lead-text"\n      ></p>\n      <p>' +
__e( url ) +
'</p>\n  </div>\n\n  <div class="ed-modal-footer ed-opt-btnbar">\n      <button\n        data-i18n="domainListing.dialog.delete.cancelButton"\n        type="button"\n        class="ed-btn ed-btn-secondary-action js-cancel"\n        data-dismiss="modal"\n      ></button>\n      <button\n        data-i18n="domainListing.dialog.delete.okButton"\n        type="button"\n        class="ed-btn ed-btn-danger js-ok"\n      ></button>\n  </div>\n</div>\n';

}
return __p
};});

